module.exports = "/images/carla.png?979e3003f55eeee55e164ed969ab1dc9";